import styled from "styled-components";

const Input = styled.input`
    border: 1px solid #000000;
    border-radius: 4px;
    padding: 0.8rem 1.2rem;
    box-shadow: var(--shadow-sm);
`;

export default Input;
